export const trendingIndices = (state) => state.trendingIndices;
export const trendingIndicesError = (state) => state.trendingIndicesError;
export const trendingIndicesLoading = (state) => state.trendingIndicesLoading;
export const trendingIndicesPageSize = (state) => state.trendingIndicesPageSize;

export const displayedTrendingIndices = (state) => {
  if (state.trendingIndices === null) return null;

  const displayedIndicesStartIndex =
    state.trendingIndicesPage * state.trendingIndicesPageSize;

  return state.trendingIndices.slice(
    displayedIndicesStartIndex,
    displayedIndicesStartIndex + state.trendingIndicesPageSize
  );
};

export const showViewMore = (state) =>
  (state.trendingIndices?.length ?? 0) > state.trendingIndicesPageSize;
